import * as ambassadorWixMultilingualSitetranslatorV2SiteTranslatableProperties from './multilingual-sitetranslator-v2-site-translatable-properties-site-translator.http.js';
import * as ambassadorWixMultilingualSitetranslatorV2SiteTranslatablePropertiesTypes from './multilingual-sitetranslator-v2-site-translatable-properties-site-translator.types.js';
import * as ambassadorWixMultilingualSitetranslatorV2SiteTranslatablePropertiesUniversalTypes from './multilingual-sitetranslator-v2-site-translatable-properties-site-translator.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function translateSite(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMultilingualSitetranslatorV2SiteTranslatablePropertiesUniversalTypes.TranslateSiteRequest,
  ambassadorWixMultilingualSitetranslatorV2SiteTranslatablePropertiesTypes.TranslateSiteRequest,
  ambassadorWixMultilingualSitetranslatorV2SiteTranslatablePropertiesUniversalTypes.TranslateSiteResponse,
  ambassadorWixMultilingualSitetranslatorV2SiteTranslatablePropertiesTypes.TranslateSiteResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMultilingualSitetranslatorV2SiteTranslatableProperties.translateSite(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/translate',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getSiteTranslatablesProperties(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMultilingualSitetranslatorV2SiteTranslatablePropertiesUniversalTypes.GetSiteTranslatablesPropertiesRequest,
  ambassadorWixMultilingualSitetranslatorV2SiteTranslatablePropertiesTypes.GetSiteTranslatablesPropertiesRequest,
  ambassadorWixMultilingualSitetranslatorV2SiteTranslatablePropertiesUniversalTypes.GetSiteTranslatablesPropertiesResponse,
  ambassadorWixMultilingualSitetranslatorV2SiteTranslatablePropertiesTypes.GetSiteTranslatablesPropertiesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMultilingualSitetranslatorV2SiteTranslatableProperties.getSiteTranslatablesProperties(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/properties',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  SiteTranslatableProperties as SiteTranslatablePropertiesOriginal,
  ApplicationTranslatableProperties as ApplicationTranslatablePropertiesOriginal,
  TranslateSiteRequest as TranslateSiteRequestOriginal,
  Locale as LocaleOriginal,
  TranslateSiteResponse as TranslateSiteResponseOriginal,
  GetSiteTranslatablesPropertiesRequest as GetSiteTranslatablesPropertiesRequestOriginal,
  GetSiteTranslatablesPropertiesResponse as GetSiteTranslatablesPropertiesResponseOriginal,
} from './multilingual-sitetranslator-v2-site-translatable-properties-site-translator.types.js';
